import { Form, FormProps, FormItemProps } from 'antd';
import React from 'react';
import Icon from '@ant-design/icons';
import MappedEventSvg from '@icons/emp/mapping-builder-lined.svg';
import isEmpty from 'lodash/isEmpty';
interface ExtendedFormItemProps extends FormItemProps {
  labelStyle?: React.CSSProperties;
}
const CustomFormItem = ({
  rules = [],
  label,
  required,
  labelStyle = {},
  ...restProps
}: ExtendedFormItemProps) => {
  let myLabel = label;

  if (label === 'Event' || label === 'Initial Event' || label === 'Follow-up Event') {
    myLabel = (
      <>
        <Icon component={MappedEventSvg} style={{ marginRight: '6px' }} />
        {myLabel}
      </>
    );
  }

  if (!isEmpty(labelStyle)) {
    myLabel = <span style={{ ...labelStyle }}>{myLabel}</span>;
  }

  if (label === null) {
    myLabel = null;
  }

  return (
    <Form.Item
      rules={rules}
      label={myLabel}
      style={{ marginBottom: '12px' }}
      {...restProps}
      required={false}
      colon={false}
    />
  );
};

export default CustomFormItem;
